import { NgModule } from "@angular/core";
import { c_subscriber_api_errors_component } from "./c_subscriber_api_errors_component";

@NgModule({
  declarations: [c_subscriber_api_errors_component],
  exports: [c_subscriber_api_errors_component],
})
export class c_subscriber_api_errors_module {}
